import React from 'react';
import { Link } from 'react-router-dom';
import { FOOTER_LINKS } from '../../../constants';

/**
 * Footer component with links and copyright
 */
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="pt-12 pb-6 border-t border-white/5 flex flex-col items-center gap-6 opacity-60 px-6">
      {/* Footer Links */}
      <div className="flex gap-6">
        {FOOTER_LINKS.map((link) => (
          <Link 
            key={link.label}
            to={link.href}
            className="text-xs font-medium hover:text-white transition-colors"
          >
            {link.label}
          </Link>
        ))}
      </div>

      {/* Copyright */}
      <p className="text-[10px] text-center tracking-wide">
        © {currentYear} MATISA MUSIC.
      </p>
    </footer>
  );
};

export default Footer;
